<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-31 
-->
<template>
  <div>
    <div class="skeleton-container" v-if="!shareImg">
      <van-skeleton title :row="6" />
    </div>
    <div class="share-image" v-else>
      <img :src="shareImg" />
    </div>
    <div class="temp">
      <div class="container" ref="temp-container">
        <div class="wrapper">
          <div class="top">
            <div class="header-logo">
              <img :src="static_img_url+'pic/vbef-logo.png'" v-if="language == 'zh'"/>
              <img :src="static_img_url+'pic/vbef-logo-en.png'" v-if="language == 'en'"/>
            </div>
            <div class="header-str">
              <p class="p1">{{'中国·苏州' | dealLanguage('CHINA·SUZHOU')}}</p>
              <p class="p2">2025.5.8-2025.5.10</p>
            </div>
          </div>
          <div class="middle">
            <div class="activity-name">{{detail.activityName | dealLanguage(detail.activityEnName)}}</div>
            <div class="ticket-name">{{detail.activityTicketName | dealLanguage(detail.activityEnTicketName)}}</div>
            <img :src="codeImg" class="code-img" />
            <div class="ticket-code">{{detail.verificationCode}}</div>
            <div class="participant-name">{{user.name}}</div>
            <div class="participant-comp">{{user.compName}}</div>
            <div class="participant-title">{{user.title}}</div>
          </div>
          <div class="bottom">
            <p class="p1">{{'场馆地址：' | dealLanguage('Address: ')}}{{detail.address | dealLanguage(detail.enAddress)}}</p>
            <p class="p2" v-if="language == 'zh'">参会时间：{{detail.startTime | time_moment('YYYY年M月D日 HH:mm')}} - {{detail.endTime | time_moment('M月D日 HH:mm')}}</p>
            <p class="p2" v-if="language == 'en'">Time: {{detail.startTime | time_moment('YYYY.M.D HH:mm')}} - {{detail.endTime | time_moment('M.D HH:mm')}}</p>
          </div>
          <div class="footer">
            <span>*</span>{{'请保存此电子确认函，会议现场扫码核销参会' | dealLanguage('Please save this electronic confirmation letter and scan the QR code at the conference site to verify your attendance.')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode'
import html2canvas from 'html2canvas'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      detail: {},
      codeImg: '',
      shareImg: '',
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      user: (state) => state.user,
      activityDetail: (state) => state.activityDetail,
      language: (state) => state.language,
    }),
  },
  methods: {
    setImg(data) {
      this.$set(this.$data, 'detail', data)
      QRCode.toDataURL(data.verificationCode, { margin: 1, height: 234, width: 234 }).then(
        (url) => {
          this.codeImg = url
          this.$nextTick(() => {
            let element = this.$refs['temp-container']
            html2canvas(element, { useCORS: true }).then((canvas) => {
              let imgUrl = canvas.toDataURL('image/png')
              this.shareImg = imgUrl
            })
          })
        }
      )
    },
    saveCode() {
      // 下载图片
      var link = document.createElement('a')
      link.href = this.shareImg
      link.download = 'downloaded_ticket_code.png' // 设置下载的文件名
      link.click() // 模拟点击，触发下载

      // 清理（可选）
      link.remove()
    },
  },
}
</script>
<style lang='stylus' scoped>
.skeleton-container
  border-radius 10px
  padding 30px 0
  box-shadow 0 4px 10px 0 rgba(0, 0, 0, 0.3)
.share-image
  width 100%
  font-size 0
  border-radius 10px
  overflow hidden
  box-shadow 0 4px 10px 0 rgba(0, 0, 0, 0.3)
  img
    width 100%
    height 100%
.temp
  width 0
  height 0
  overflow hidden
  .container
    width 686px
    background linear-gradient(135deg, #FFD0A9 1%, #EB6F07 100%)
    .wrapper
      width 100%
      min-height 1100px
      padding 25px 25px 100px
      background-image url('~pic/code-bg.png')
      background-repeat no-repeat
      background-size 100% auto
      background-position bottom
      position relative
    .top
      width 100%
      height 86px
      background #FFFFFF
      border-radius 10px
      padding 0 20px
      display flex
      align-items center
      justify-content space-between
      .header-logo
        width auto
        height 36px
        img
          width auto
          height 100%
      .header-str
        font-size 16px
        color #FF8824
        height 36px
        text-align right
        line-height 1
        .p2
          margin-top 4px
    .middle
      background #FFFFFF
      border-radius 10px
      margin-top 10px
      padding 20px
      text-align center
      .activity-name
        font-size 26px
        color #333333
        line-height 42px
      .ticket-name
        line-height 42px
        font-size 36px
        color #EE7700
      .code-img
        width 234px
        height 234px
        margin 12px auto 0
        display block
      .ticket-code
        font-size 26px
        color #333333
        line-height 36px
        margin-top 16px
      .participant-name
        margin-top 25px
        padding-top 25px
        border-top 1px solid #EE7700
        font-size 36px
        color #333333
        line-height 42px
      .participant-comp, .participant-title
        margin-top 16px
        font-size 24px
        color #666666
        line-height 21px
    .bottom
      padding 30px 20px
      .p1, .p2
        font-size 26px
        color #FFFFFF
        line-height 36px
      .p2
        margin-top 16px
    .footer
      text-align center
      font-size 22px
      color #FFFFFF
      line-height 31px
      position absolute
      bottom 20px
      left 25px
      right 25px
      span
        color #FF0000
</style>